export default "__VITE_ASSET__BNSnFkH$__"